import { ChangeEvent, FC, useEffect, useRef, useState } from "react";
import {
  CloseOutlined,
  EditOutlined,
  LoadingOutlined,
  SaveOutlined
} from "@ant-design/icons";
import type { InputRef } from 'antd';
import { Input, Badge } from "antd";
import cn from "classnames";

import { IEditInfoScreen } from 'types/infoScreens.types';
import styles from './index.module.scss';

type EditableContentProps = {
  children?: string;
  type?: 'header' | 'body';
  maxLength?: number;
  onSave: (data: IEditInfoScreen) => Promise<any>;
}

export const EditableContent: FC<EditableContentProps> = ({
  children,
  onSave,
  type = 'body',
  maxLength
}) => {
  const inputRef = useRef<InputRef>(null);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState<string | undefined>(children);
  useEffect(() => {
    edit && inputRef.current?.focus({
      cursor: 'end',
    });
  }, [edit]);
  const handleClickEdit = () => {
    setValue(children);
    setEdit(true);
  };
  const handleClickCancel = () => {
    setEdit(false);
  };
  const handleClickSave = () => {
    setLoading(true);
    onSave({ [type]: value })
      .then(() => {
        setEdit(false);
        setLoading(false);
      });
  };
  const onChangeInput = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };
  return (
    <Badge.Ribbon
      text={(
        edit
          ? loading
            ? <LoadingOutlined />
            : children === value
              ? <CloseOutlined onClick={handleClickCancel} />
              : <SaveOutlined onClick={handleClickSave} />
          : <EditOutlined onClick={handleClickEdit} />
      )}
    >
      <div className={cn(styles.wrapper, styles[type])}>
        <Input.TextArea
          ref={inputRef}
          readOnly={!edit || loading}
          bordered={false}
          value={edit ? value : value || "Добавьте текст"}
          onChange={onChangeInput}
          autoSize
          showCount={edit}
          maxLength={maxLength}
        />
      </div>
    </Badge.Ribbon>
  );
};